import { NextPage } from 'next';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import PolicyService from 'modules/policies/services/policy.service';
import { useUserStore } from 'common/stores/user-store';
import { useAuthSession } from 'modules/auth/hooks/use-auth-session';
import { useJourneyStore } from 'common/stores/journey-store';
import { DEFAULT_PAGE_NUMBER, PAGE_SIZE } from 'common/utils/constants/page.constants';
import { UserService } from 'modules/user-profile/services/user.service';

const RedirectPage: NextPage = () => {
  const router = useRouter();
  const setCustomerAffinity = useUserStore((state) => state.setCustomerAffinity);
  const { user } = useAuthSession();
  const setFormData = useJourneyStore((state) => state.setFormData);
  const [hasRedirected, setHasRedirected] = useState(false);
  const setUserDetail = useUserStore((state) => state.setUserDetail);

  useEffect(() => {
    async function redirectFunc() {
      const landingProduct = router.query.productName
        ? (router.query.productName as string)
        : user?.landingProduct
        ? user?.landingProduct.toUpperCase()
        : '';

      const landingFlow = user?.landingFlow ? user?.landingFlow : 'QnB';
      const res = await PolicyService.getIntialCustomerPolicyData(landingProduct, landingFlow).then((res) => res);
      const policiesStatus = await PolicyService.getPoliciesStatus(DEFAULT_PAGE_NUMBER, PAGE_SIZE).then((res) => res);
      const userDetail = await UserService.getCustomerInformation();

      if (policiesStatus.active === 0 && policiesStatus.quote === 0) {
        let updatedUser = await UserService.updateUserData(userDetail.content.civilRegistrationCode, 'Y');
        
        if (!userDetail.content.customerSegments || userDetail.content.customerSegments === "") {
          updatedUser = await UserService.updateUserSegment('P');
        }
        setUserDetail(updatedUser);
        
      } else {
        //Redirect to update-profile if last_login is more than 90 days
        const date = new Date(userDetail?.content?.last_login);
        const currentDate = new Date();
        const dayDifference: number = (currentDate.getTime() - date.getTime()) / (1000 * 3600 * 24);

        if (dayDifference > 90) {
          router.push('/update-profile');
          setHasRedirected(true);

          return;
        }
      }

      if (hasRedirected) {
        return;
      }

      if (res.customerAffinity) {
        setCustomerAffinity(res.customerAffinity);
      }

      if (res && res.redirectToJourney) {
        if (res.redirectToProduct) {
          setFormData({
            ...res.journeyData,
          });
        }

        router.push('/journeys/get-quote');
        setHasRedirected(true);
      } else if (policiesStatus.active === 0 && policiesStatus.cancelled === 0) {
        router.push('/quotes');
        setHasRedirected(true);
      } else {
        router.push('/dashboard');
        setHasRedirected(true);
      }
    }

    redirectFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default RedirectPage;
